export enum FlightType {
  one = 0,
  two = 1,
}
